import { Link } from "react-router-dom";
import '../../assets/css/public-pages.css'
import AiBgVideo from "../../assets/Video/0_Background_Business_3840x2160.webm";
import CheckListBlu from "../../assets/images/public-pages/checkListBlu.svg";
import CheckBoxBlu from "../../assets/images/public-pages/checkBoxBlu.svg";
import ButtonComp from "./ButtonComp";
import { SkeletonVideo } from "./MediaWithSkeleton";

const AiPower = ({btnText="Register For Free",img="/images/web-new-images/new-dark-arrow.svg"}) => {

    return (
        <>
            {/* AI-Powered Precision Section */}
            <div id="aipowersection" className="ai-section py-5" >
                <SkeletonVideo
                    fill
                    className="ai-bg-video"
                    autoPlay
                    muted
                    loop
                    playsInline
                    skeletonVariant="dark"
                >
                    <source src={AiBgVideo} type="video/webm" />
                </SkeletonVideo>
                <div className="ai-overlay"></div>

                <div className="ai-container">
                    {/* Top-left card */}
                    <div className="ai-card ai-card--top-left">
                        <div className="ai-card__header">
                            <div className="ai-card__icon ai-card__icon--green">
                                <img src={CheckListBlu} alt="" width="100%" height="100%" />
                            </div>
                            <h3 className="ai-card__title">Faster Results</h3>
                        </div>
                        <p className="ai-card__desc">
                            Get instant mock test scores with our AI evaluation. Quick, accurate feedback helps you improve.
                        </p>
                    </div>

                    {/* Top-right card */}
                    <div className="ai-card ai-card--top-right">
                        <div className="ai-card__header">
                            <div className="ai-card__icon">
                                <img src={CheckBoxBlu} alt="" width="100%" height="100%" />
                            </div>
                            <h3 className="ai-card__title">Detailed Performance Insights</h3>
                        </div>
                        <p className="ai-card__desc">
                            Analyze strengths, weaknesses, and skills. The system shows improvement areas for students to focus on.
                        </p>
                    </div>

                    {/* Center content */}
                    <div className="ai-center">
                        <h3 className="ai-heading">
                            AI-Powered Precision For<br />
                            <span className="green-text">Smarter Mock Test Evaluation</span>
                        </h3>
                        <p className="ai-text">
                            Our AI system analyzes mock tests accurately. It identifies weak areas and tracks
                            performance trends, delivering insights quickly for fair evaluation and faster feedback.
                        </p>
                        <ButtonComp link={"/auth/register"} btnText={btnText} img={img}/>
                    </div>

                    {/* Bottom-left card */}
                    <div className="ai-card ai-card--bottom-left">
                        <div className="ai-card__header">
                            <div className="ai-card__icon">
                                <img src={CheckBoxBlu} alt="" width="100%" height="100%" />
                            </div>
                            <h3 className="ai-card__title">Personalized Recommendations</h3>
                        </div>
                        <p className="ai-card__desc">
                            AI suggests targeted practice strategies to help students boost scores confidently.
                        </p>
                    </div>

                    {/* Bottom-right card */}
                    <div className="ai-card ai-card--bottom-right">
                        <div className="ai-card__header">
                            <div className="ai-card__icon">
                                <img src={CheckBoxBlu} alt="" width="100%" height="100%" />
                            </div>
                            <h3 className="ai-card__title">Accurate Scoring</h3>
                        </div>
                        <p className="ai-card__desc">
                            AI ensures precise, unbiased evaluation aligned with real exam standards for dependable results.
                        </p>
                    </div>
                </div>
            </div >
        </>
    )
};
export default AiPower;